const scaleBarInputConfigs = {
    low: {
        text: {
            label: 'Не соответствует',
            color: 'accent.text.error'
        },
        level: {
            color: 'accent.text.error',
            strokeColor: 'accent.stroke.error'
        }
    },
    normal: {
        text: {
            label: 'Соответствует',
            color: 'accent.text.success'
        },
        level: {
            color: 'accent.text.success',
            strokeColor: 'accent.stroke.success'
        }
    },
    high: {
        text: {
            label: 'Превышает',
            color: 'original.brand.primary'
        },
        level: {
            color: 'accent.text.blue',
            strokeColor: 'accent.stroke.blue'
        }
    }
};
export { scaleBarInputConfigs };
